// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_POST_PLACEHOLDER = "Za\u010dni ps\u00e1t p\u0159\u00edsp\u011bvek...";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnou zpr\u00e1vu nem\u016f\u017ee\u0161 odeslat";
export const HIDE_REPLIES = "Nezobrazuj koment\u00e1\u0159e";
export const SEND_COMMENT_FORUM = "Ode\u0161li";
export const SHOW_IN_CONTESTS = "Zobrazuj v \"Sout\u011b\u017ee\"";
export const VISIBILITY_CHECKBOX_LABEL = "Zve\u0159ejni i pro neregistrovan\u00e9";
